import {ReelBounceTime, ReelConstants, ReelPositionsConfig, ReelsFullStopTime, SymbolPosition, SymbolSizes} from '@gongxigames/framework/slot/utils/ReelConstants';

export class IndependentReelConstants extends ReelConstants {

    public static REELS_OFFSETS: SymbolPosition = {
        x: 0,
        y: 0
    };

    public static SYMBOL: SymbolSizes = {
        width: 0,
        height: 0
    };

    public static SYMBOL_SLOT: SymbolSizes = {
        width: 0,
        height: 0
    };

    public static FIRST_REEL_STOP_TIME = 1000;
    public static REEL_BOUNCE_TIME: number = ReelBounceTime.normal;
    public static REELS_FULL_STOP_TIME: number = ReelsFullStopTime.normal;
    public static REEL_BOUNCE_EFFECT: any;

    public static readonly FIRST_VISIBLE_ROW: number = 2;
    public static readonly FIRST_VISIBLE_ROW_ON_STOP: number = 1;
    public static ROW_AMOUNT = 0;
    public static REELS_AMOUNT = 0;

    public static REELS: ReelPositionsConfig[] = [];

    public static readonly QUICKSTOP_TIMER: number = 0;
    public static readonly Y_ADDITIONAL_SYMBOLS_OFFSET: number = -2;
    public static readonly REEL_SPEED_MULTIPLIER: number = 8;

    public static getBetweenReelsStoppingTime(isTurbo?: boolean): number {
        const fullBounceTime = IndependentReelConstants.REEL_BOUNCE_TIME * (IndependentReelConstants.REELS_AMOUNT - 1);
        const deltaTime = IndependentReelConstants.REELS_FULL_STOP_TIME - (fullBounceTime + IndependentReelConstants.FIRST_REEL_STOP_TIME);

        return isTurbo ? 0 : (deltaTime / (IndependentReelConstants.REELS_AMOUNT)) + IndependentReelConstants.REEL_BOUNCE_TIME;
    }
}
